import * as React from 'react';
import { Search } from 'telia-front-react';
import { debounce } from 'throttle-debounce';
import { getFuseResults } from '../../../util/FuseUtil';
import { withAnalytics } from '../util/AnalyticsUtil';
const mapFuseResults = (input, fuzzySearch) => {
    return getFuseResults(fuzzySearch.search(input));
};
const DEBOUNCE_TIMEOUT = 300;
class ChannelSearch extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = (input) => {
            this.setState({
                searchTerm: input,
                invalid: false
            });
            this.debouncedFetchSuggestions(input);
        };
        this.onSubmit = (event) => {
            event.preventDefault();
            this.props.pushAnalytics('Submit search');
            this.debouncedFetchSuggestions.cancel();
            this.debouncedFetchSuggestions = debounce(DEBOUNCE_TIMEOUT, this.doSearch);
            const selectedItem = {
                label: this.state.searchTerm,
                url: ''
            };
            this.props.onSelect(selectedItem);
        };
        this.state = {
            searchTerm: '',
            currentSuggestions: [],
            invalid: false
        };
        this.debouncedFetchSuggestions = debounce(DEBOUNCE_TIMEOUT, this.doSearch);
    }
    componentDidUpdate(prevProps) {
        var _a;
        if (prevProps.selectedItem !== this.props.selectedItem) {
            this.setState({ searchTerm: ((_a = this.props.selectedItem) === null || _a === void 0 ? void 0 : _a.label) || '' });
        }
    }
    doSearch(input) {
        const newSuggestions = input.length > 1 ? mapFuseResults(input, this.props.fuzzySearch) : [];
        this.setState({
            currentSuggestions: newSuggestions
        });
    }
    render() {
        const { translate, onSelect, pushAnalytics } = this.props;
        const { searchTerm, currentSuggestions, invalid } = this.state;
        return (React.createElement(Search, { id: "channel-search", label: `${translate('tvcomparison.textfield.label')}`, value: searchTerm, onChange: this.onChange, onSelect: onSelect, onSubmit: this.onSubmit, isClearable: true, onClear: () => {
                this.setState({ searchTerm: '' });
                onSelect(null);
                pushAnalytics('Button - Clear search');
            }, items: currentSuggestions, input: { autoComplete: 'off' }, isInvalid: invalid, minValueLength: 2 }));
    }
}
export default withAnalytics(ChannelSearch);
